import React, { useState, useEffect } from "react";
import "./../../../../assets/css/purchase/form.css";

// Components
import Breadcrumbs from "../../../components/Breadcrumbs";
import {
  deleteData,
  getAlert,
  insertData,
  parseCurrency,
  updateData,
  updateQty,
} from "../../../../utils/SamuiUtils";

const Form = ({
  callInitialize,
  mode,
  name,
  formData,
  setFormData,
  selectedData,
}) => {
  const [initialFormData, setInitialFormData] = useState({});
  
  // Keyboard shortcuts
  useEffect(() => {
    const handleKeyDown = (event) => {
      // Prevent shortcuts when typing in input fields
      if (event.target.tagName === 'INPUT' || event.target.tagName === 'TEXTAREA' || event.target.tagName === 'SELECT') {
        return;
      }
      
      // ESC key - Cancel/Back
      if (event.key === 'Escape') {
        event.preventDefault();
        if (window.confirm('ต้องการยกเลิกการทำงานหรือไม่?')) {
          window.location.href = "/unit";
        }
      }
      
      // F10 key - Save
      if (event.key === 'F10') {
        event.preventDefault();
        if (mode === "I") {
          confirmAndSubmit();
        } else {
          confirmAndUpdate();
        }
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, []);

  useEffect(() => {
    const compId = localStorage.getItem("company");
    if (compId) {
      setFormData((prevData) => ({
        ...prevData,
        comp_id: compId,
      }));
    }
  }, [setFormData]);

  useEffect(() => {
    if (mode === "I") {
      const initialData = {
        comp_id: parseCurrency(window.localStorage.getItem("company"), 10),
        Unit_Id: 0,
        Unit_Name: "",
        Unit_Status: "Y",
      };
      setFormData(initialData);
      setInitialFormData(initialData);
    } else if (mode === "U") {
      const initialData = {
        comp_id: parseCurrency(selectedData.Comp_Id, 10),
        Unit_Id: parseCurrency(selectedData.Unit_Id, 10),
        Unit_Name: selectedData.Unit_Name,
        Unit_Status: selectedData.Unit_Status,
      };
      setFormData(initialData);
      setInitialFormData(initialData);
    }
  }, [mode, setFormData, selectedData]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleInsertTbsetItem = async () => {
    try {
      const { Unit_Id, ...dataToInsert } = formData;

      // สร้าง fields และ values
      const fields = Object.keys(dataToInsert).join(", ");
      const values = Object.values(dataToInsert);

      // เรียกใช้ insertData
      const res = await insertData("Tb_Set_Unit", fields, values);

      if (res?.status === "OK") {
        getAlert("OK", "บันทึกสำเร็จ");
        callInitialize();
      } else {
        getAlert("FAILED", res?.message || "ไม่สามารถบันทึกข้อมูลได้");
      }
    } catch (error) {
      console.error("Error inserting data:", error);
      getAlert(
        "FAILED",
        "ไม่สามารถบันทึกข้อมูลได้ เนื่องจากมีข้อมูลนี้อยู่ในระบบแล้ว"
      );
    }
  };

  const formatValues = (data) => {
    const { Unit_Id, ...rest } = data;
    return rest;
  };
  
  const handleUpdateTbsetItem = async () => {
    try {
      const where = { Unit_Id: formData.Unit_Id };
      const values = formatValues(formData);
      const res = await updateData("Tb_Set_Unit", values, where);
      
      if (res) {
        const unitId = formData.Unit_Id;
        const newUnitName = formData.Unit_Name;
        
        try {
          await updateQty(
            "Tb_Set_Item",
            `Item_Unit_IN = CASE WHEN unit_in_id = ${unitId} THEN '${newUnitName}' ELSE Item_Unit_IN END,
             Item_Unit_ST = CASE WHEN unit_st_id = ${unitId} THEN '${newUnitName}' ELSE Item_Unit_ST END,
             Item_Unit_OUT = CASE WHEN unit_out_id = ${unitId} THEN '${newUnitName}' ELSE Item_Unit_OUT END`,
            `WHERE unit_in_id = ${unitId} OR unit_st_id = ${unitId} OR unit_out_id = ${unitId}`
          );
          
          getAlert("OK", "อัปเดตข้อมูลสำเร็จ และอัปเดทชื่อหน่วยนับในสินค้าที่เกี่ยวข้องแล้ว");
        } catch (updateError) {
          console.error("Error updating related items:", updateError);
          getAlert("WARNING", "อัปเดตข้อมูลหน่วยนับสำเร็จ แต่อาจมีบางสินค้าที่ไม่ได้รับการอัปเดท");
        }
        
        callInitialize();
      }
    } catch (error) {
      console.error("Error updating unit:", error);
          getAlert(
        "FAILED",
        "ไม่สามารถอัปเดตข้อมูลได้ เนื่องจากมีข้อมูลนี้อยู่ในระบบแล้ว"
      );
      return null;
    }
  };

  const handleDelete = async () => {
    try {
      getAlert("C_DIALOG", "ยืนยันการลบข้อมูล", async (isConfirm) => {
        if (isConfirm) {
          await deleteData(
            "Tb_Set_Unit",
            `WHERE Unit_Id = ${selectedData.Unit_Id}`
          );
          getAlert("OK", "ลบข้อมูลสำเร็จ");
          await callInitialize();
        }
      })
    } catch (error) {
      getAlert("FAILED", "ไม่สามารถลบข้อมูลได้ กรุณาลองใหม่อีกครั้ง");
    }
  };

  const handleSubmit = async (e) => {
    try {
      if (mode === "I") {
        await handleInsertTbsetItem();
      } else if (mode === "U") {
        await handleUpdateTbsetItem();
      }
      await callInitialize();
      setFormData({
        comp_id: parseCurrency(window.localStorage.getItem("company"), 10),
        Unit_Id: 0,
        Unit_Name: "",
        Unit_Status: "Y",
      });
    } catch (error) {
      console.error("Error in handleSubmit:", error);
      getAlert(
        "WARNING",
        "โปรดตรวจสอบข้อมูลอีกครั้ง ข้อมูลนี้มีอยู่ในระบบแล้ว"
      );
      return null;
    }
  };

  // Confirm wrappers
  const confirmAndSubmit = async () => {
    try {
      getAlert("C_DIALOG", "ยืนยันการบันทึกข้อมูลหน่วยนับ?", async (isConfirm) => {
        if (isConfirm) {
          await handleSubmit();
        }
      });
    } catch (error) {
      console.error("confirmAndSubmit error:", error);
    }
  };

  const confirmAndUpdate = async () => {
    try {
      getAlert("C_DIALOG", "ยืนยันการอัปเดตข้อมูลหน่วยนับ?", async (isConfirm) => {
        if (isConfirm) {
          await handleUpdateTbsetItem();
        }
      });
    } catch (error) {
      console.error("confirmAndUpdate error:", error);
    }
  };

  return (
    <form>
      <Breadcrumbs
        isShowStatus={mode === "U"}
        items={[
          { name: "ข้อมูลตั้งต้น", url: "/initialdata" },
          { name: name, url: "/unit" },
          { name: mode === "U" ? "เรียกดู" + name : "สร้าง" + name, url: "#" },
        ]}
      />
      <div className="container py-4">
        <div className="card shadow-sm">
          <div className="card-body">
            <h5 className="mb-3 border-bottom pb-2">ข้อมูลหน่วยนับ</h5>
            <div className="row g-3">
              <div className="col-6">
                <label>ชื่อหน่วยนับ</label>
                <input 
                  type="text" 
                  className="form-control" 
                  name="Unit_Name" 
                  value={formData.Unit_Name || ""} 
                  onChange={handleChange} 
                  maxLength={50}
                />
              </div>
              <div className="col-6">
                <label>สถานะ</label>
                <select 
                  className="form-select" 
                  name="Unit_Status" 
                  value={formData.Unit_Status || "Y"} 
                  onChange={handleChange}
                >
                  <option value="Y">ใช้งาน</option>
                  <option value="N">ไม่ใช้งาน</option>
                </select>
              </div>
            </div>

            <div className="row mt-4">
              {mode !== "I" ? (
                <div className="d-flex justify-content-end gap-2">
                  <button onClick={() => (window.location.href = "/unit")} type="button" className="btn btn-dark btn-lg">ยกเลิก (ESC)</button>
                  <button onClick={confirmAndUpdate} type="button" className="btn btn-warning text-white btn-lg">บันทึก (F10)</button>
                </div>
              ) : (
                <div className="d-flex justify-content-end gap-2">
                  <button onClick={() => (window.location.href = "/unit")} type="button" className="btn btn-dark btn-lg">ยกเลิก (ESC)</button>
                  <button onClick={confirmAndSubmit} type="button" className="btn btn-warning text-white btn-lg">บันทึก (F10)</button>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </form>
  );
};

export default Form;
